import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-classification-banner',
    templateUrl: './classification-banner.component.html',
    styleUrls: ['./classification-banner.component.scss'],
})
export class ClassificationBannerComponent {
  @Input() text?: string;
  @Input() color?: string;
}
